import { render, staticRenderFns } from "./KycAddressProofDocument.vue?vue&type=template&id=a7f41438&scoped=true&"
import script from "./KycAddressProofDocument.vue?vue&type=script&lang=js&"
export * from "./KycAddressProofDocument.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=a7f41438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f41438",
  null
  
)

export default component.exports